import './start.css';

const Title = () => {
  return (
    <header className="header">
      <h1>Mines</h1>
    </header>
  );
};

export default Title;
